/**
 * Translation keys for the /faq archive UI shell — hero, search, sidebar
 * categories, and CTAs. The Q&A content itself lives in CMS, so there are no
 * per-question keys here.
 *
 * Real category names + descriptions also live in CMS now (the
 * `faq-categories` collection). The only category copy left in messages is
 * the synthesized "Most popular" virtual category — it's not a CMS row, it's
 * computed at render time from FAQ items with `featured: true`.
 */
export const faqKeys = {
  // Hero
  heroEyebrow: "faq_heroEyebrow", // "Everything you need to know" — small uppercase brandy line
  heroHeading: "faq_heroHeading", // "Frequently asked questions" — clear H1
  heroSubtitlePrefix: "faq_heroSubtitlePrefix", // "Can't find the answer you're looking for?"
  heroSubtitleLink: "faq_heroSubtitleLink", // "Reach out to our team"
  openQuestionPage: "faq_openQuestionPage", // accordion link to /faq/[slug] page

  // Bottom CTA
  ctaHeading: "faq_ctaHeading", // "Still have questions?"
  ctaText: "faq_ctaText", // "Our team is here to help..."
  ctaMessageLink: "faq_ctaMessageLink", // "send us a message"
  ctaBookButton: "faq_ctaBookButton", // "Book advisory call"
  ctaPricingButton: "faq_ctaPricingButton", // "See pricing"

  // Synthesized "Most popular" virtual category
  catMostPopular: "faq_catMostPopular", // "Most popular" — sidebar label
} as const
